import { computed, ref } from 'vue';
import { AiChatService } from '@/api';

const _aiChatEnabled = ref<boolean | null>(null);

export const aiChatEnabled = computed(() => _aiChatEnabled.value === true);

export const refreshAiChatAvailability = async (): Promise<void> => {
  try {
    const settings = await AiChatService.getAiChatSettings();
    _aiChatEnabled.value = settings.aiChatEnabled ?? false;
  } catch {
    _aiChatEnabled.value = false;
  }
};
